//@flow
import React from 'react'

import { Button, Error, Flex } from 'components/common'
import { useI18n } from '~/core/i18n'

type AcceptTemplateProps = {
  error?: any,
  text?: string,
  isLoading?: boolean,
  onAccept: () => any
}

const AcceptTemplate = ({ text, error, isLoading, onAccept }: AcceptTemplateProps) => {
  const [msg] = useI18n()
  return (
    <Flex
      column
      style={{
        padding: '0.5rem',
        minWidth: 500,
        maxWidth: '50vw',
        alignItems: 'center'
      }}
    >
      {error && <Error reason={error} />}
      <Flex alignCenter as="p" justifyCenter>
        <i
          className="icon icon-l"
          style={{
            marginRight: '1rem'
          }}
        >
          circle_exclamation
        </i>
        <span>{text || msg('common.modal.acceptText')}</span>
      </Flex>
      <Flex
        justifyCenter
        style={{
          marginTop: '1.5rem'
        }}
      >
        <Button
          disabled={isLoading}
          iconPosition="left"
          id="template-accept-btn"
          type="submit"
          xIcon="check"
          onClick={onAccept}
        >
          {isLoading ? msg('common.button.processing') : msg('common.button.accept')}
        </Button>
      </Flex>
    </Flex>
  )
}

export default AcceptTemplate
